<template>
    <body>
    <div class="myPost_wrapper">
      <!-- title -->
      <div class="main_top">
        <h1>
         <img src="images/basic/icon/back.svg" onclick="history.back()" class="back">
         레벨안내
        </h1>
      </div>
      <div class="div_padding" style="height:55px"></div>


      <div class="notice">
        <p>레벨 산정 기준과 정책</p>
        <span>레벨의 경험치는 현재 보유중인 FUS를 기반으로 기준에 도달하게 되면 레벨업이 됩니다. 선물을 받거나 외부에서 획득한 FUS도 경험치에 반영이 됩니다. 레벨마다 이용하실 수 있는 컨텐츠에 차이가 있으며, 레벨 유지에 필요한 경험치에 미달할 경우 레벨이 내려갑니다.</span>
      </div>
      <div class="level_table">
        <table>
          <tr>
            <th>레벨</th>
            <th>기준</th>
            <th>이용 가능한 컨텐츠</th>
          </tr>
          <tr>
            <td>Lv.1</td>
            <td>0</td>
            <td>룰렛 채굴, 커뮤니티 외 모든 컨텐츠 제한</td>
          </tr>
          <tr>
            <td>Lv.2</td>
            <td>1</td>
            <td>슬롯머신, 선물 제한</td>
          </tr>
          <tr>
            <td>Lv.3</td>
            <td>5,000</td>
            <td>슬롯머신 제한</td>
          </tr>
          <tr>
            <td>Lv.4</td>
            <td>10,000</td>
            <td>모든 컨텐츠 이용가능</td>
          </tr>
          <tr>
            <td>Lv.5</td>
            <td>20,000</td>
            <td>추가 FUS +1%</td>
          </tr>
          <tr>
            <td>Lv.6</td>
            <td>50,000</td>
            <td>추가 FUS +2%</td>
          </tr>
          <tr>
            <td>Lv.7</td>
            <td>100,000</td>
            <td>추가 FUS +3%, 채굴 쿨타임 10% 감소</td>
          </tr>
          <tr>
            <td>Lv.8</td>
            <td>500,000</td>
            <td>추가 FUS +3%, 채굴 쿨타임 15% 감소</td>
          </tr>
          <tr>
            <td>Lv.9</td>
            <td>500,000+</td>
            <td>추가 FUS +5%, 채굴 쿨타임 20% 감소</td>
          </tr>
        </table>
      </div>

      <div class="level_info">
        <p>FUS를 얻는 다양한 방법</p>
        <table>
          <tr>
            <th>획득</th>
            <th>컨텐츠</th>
            <th>이용안내</th>
          </tr>
          <tr>
            <td>+10</td>
            <td>친구초대</td>
            <td>초대한 친구가 가입할때마다 지급</td>
          </tr>
          <tr>
            <td>+5</td>
            <td>광고채굴</td>
            <td>광고를 볼때마다 지급</td>
          </tr>
          <tr>
            <td>+4</td>
            <td>출석체크</td>
            <td>출석체크하면 지급, 3일연속 출석시 +1!</td>
          </tr>
          <tr>
            <td>+3</td>
            <td>선물하기</td>
            <td>선물 할때마다 지급</td>
          </tr>
          <tr>
            <td>+5%</td>
            <td>쇼핑금액</td>
            <td>쇼핑할때마다 페이백</td>
          </tr>
          <tr>
            <td>+3</td>
            <td>글쓰기</td>
            <td>글 쓸때마다 지급. 레벨 x10만큼 횟수 제한</td>
          </tr>
          <tr>
            <td>+2</td>
            <td>댓글</td>
            <td>댓글 쓸때마다 지급. 레벨 x10만큼 횟수 제한</td>
          </tr>
          <tr>
            <td>+1</td>
            <td>하트</td>
            <td>하트를 줄때 지급. 레벨 x10만큼 횟수 제한</td>
          </tr>
          <tr>
            <td style="line-height:4vw">매주<br>+200</td>
            <td>파티장</td>
            <td style="line-height:4vw">100명 이상 모집시 매주 월요일 지급.<br>30명 이상 활동이 있어야 권한이 유지</td>
          </tr>
        </table>
      </div>
    </div>
  </body>  
</template>

<script>
export default {

}
</script>

<style>

</style>